import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default{
    namespaced:true,
    state(){
        return{
            messages:[],
            createMessage:false,
            theMessage:{},
            verified:false

        }
    },
    mutations,
    getters,
    actions
}